import React, { useReducer, useCallback, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Button, Form, FormGroup, Input, Label, Card, Col, Row, InputGroupAddon, InputGroup } from 'reactstrap';
import logo200Image from '../assets/img/logo/logo_200.png';
import { MdVisibilityOff, MdVisibility } from 'react-icons/md';
// components
import ButtonLoader from '../mycomponents/Layout/ButtonLoader';
// lib
import handleReducer, { textChange, onBlur } from '../lib/handleChange';
import toastAlert from '../lib/toastAlert';

// import validation
import { loginValid } from '../validation/auth.validation';
// api
import { login } from '../api/admin';
import isEmpty from '../lib/isEmpty';

const initialFormValue = {
    'email': '',
    'password': '',
    'tfaStatus': false,
    'code': ''
}

const Login = () => {

    // hooks
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [formValue, setFormValue] = useReducer(handleReducer, initialFormValue);
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [loader, setLoader] = useState(false);
    const { email, password, tfaStatus, code } = formValue;

    const handleChange = (e) => textChange(e, setFormValue);
    const handleBlur = (e) => onBlur(e, setTouched)

    const handleSubmit = useCallback(async (e) => {
        e.preventDefault();
        try {
            setLoader(true)
            const { status, tfaStatus, errors, message } = await login(formValue, dispatch);
            setLoader(false)
            if (status === true) {
                setFormValue({ type: 'RESET', value: initialFormValue })
                toastAlert('success', message, 'login')
                setErrors({})
                navigate('/')
            } else if (status === false && tfaStatus === true) {
                setFormValue({ type: 'SET', value: { ...formValue, ...{ tfaStatus } } })
                toastAlert('error', message, 'login')
            } else if (errors) {
                setErrors(errors)
            } else if (message) toastAlert('error', message, 'login')
        } catch (err) {
            console.log(err, 'errrr')
        }
    }, [formValue, navigate, dispatch]);

    useEffect(() => {
        const { status, errors } = loginValid(formValue)
        if (!status) setErrors(errors);
        else setErrors({});
    }, [formValue])

    return (
        <Row
            style={{
                height: '100vh',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
            <Col md={6} lg={4}>
                <Card body>
                    <Form onSubmit={handleSubmit}>
                        <div className="text-center pb-4">
                            <img
                                src={logo200Image}
                                className="rounded"
                                style={{ width: 60, height: 60, cursor: 'pointer' }}
                                alt="logo"
                            />
                        </div>
                        <FormGroup>
                            <Label for={'Email'}>{'Email'}</Label>
                            <Input
                                type="text"
                                placeholder="your@email.com"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={email}
                                name={'email'}
                                valid={isEmpty(errors.email)}
                            />
                            {touched?.email && <span className='text-danger'>{errors && errors.email}</span>}
                        </FormGroup>
                        <FormGroup>
                            <Label for={'Password'}>{'Password'}</Label>
                            <InputGroup>
                                <Input
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="your password"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={password}
                                    name={'password'}
                                    valid={isEmpty(errors.password)}
                                />
                                <InputGroupAddon addonType="append">
                                    <Button onClick={() => setShowPassword(!showPassword)}>
                                        {showPassword ? <MdVisibility /> : <MdVisibilityOff />}
                                    </Button>
                                </InputGroupAddon>
                            </InputGroup>
                            {touched?.password && <span className='text-danger'>{errors && errors.password}</span>}
                        </FormGroup>

                        {
                            (tfaStatus === true) && (
                                <FormGroup>
                                    <Label for={'TFA Code'}>{'TFA Code'}</Label>
                                    <Input
                                        type="text"
                                        placeholder="Enter a TFA Code"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={code}
                                        name={'code'}
                                        valid={isEmpty(errors.code)}
                                    />
                                    {touched?.code && <span className='text-danger'>{errors && errors.code}</span>}
                                </FormGroup>
                            )
                        }
                        {/* <FormGroup check>
                            <Label check>
                                <Input type="checkbox" />
                                Remember me
                            </Label>
                        </FormGroup> */}
                        <hr />
                        <ButtonLoader
                            loader={loader}
                            size="lg"
                            className="bg-gradient-theme-left border-0"
                            block
                            text="Login"
                            onClick={handleSubmit}
                            disabled={!isEmpty(errors)}
                        />
                    </Form>
                </Card>
            </Col>
        </Row >
    );
}

export default Login;